const PolygonForModal = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="440"
      height="560"
      viewBox="0 0 440 560"
      fill="none"
    >
      <g filter="url(#filter0_f_99_558)">
        <circle
          cx="220"
          cy="269"
          r="206"
          fill="url(#paint0_linear_99_558)"
          fill-opacity="0.7"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_99_558"
          x="-186"
          y="-137"
          width="812"
          height="812"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_99_558"
          />
        </filter>
        <linearGradient
          id="paint0_linear_99_558"
          x1="220"
          y1="63"
          x2="220"
          y2="475"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2D061B" />
          <stop offset="1" stop-color="#B9317A" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PolygonForModal;
